import React from "react"
import { Container, Heading, Text, Button, Box, AspectRatio, Stack } from "@chakra-ui/react"

import { useRoutes } from "@hooks/useRoutes"
import { useImage } from "@hooks/useImage"
import Link from "@components/Link"
import Image from "@components/Image/Image"
import { CallToActionProps } from "./CallToAction"
import Illustration from "@components/Illustration"

const CallToActionDesktop = ({
  title,
  content,
  image: rawImage,
  link: rawLink,
  handleTrackingClick,
}: Omit<CallToActionProps, "innerRef">) => {
  const { getResponsiveImage } = useImage()
  const { urlResolver } = useRoutes()

  const image = getResponsiveImage(rawImage)
  const parsedLink = urlResolver(rawLink)

  return (
    <Container as="section" pt={6} pb={3}>
      <Box pos="relative">
        {image && (
          <AspectRatio ratio={324 / 223} w="50%">
            <Image {...image} borderRadius="sm" objectFit="cover" />
          </AspectRatio>
        )}
        <Illustration name="bundle" pos="absolute" left="20px" top="-55px" mixBlendMode={`multiply`} />
        <Box
          pos="absolute"
          bg="brand.beige.dark"
          borderRadius="sm"
          py={4}
          px={8}
          w="55%"
          top="50%"
          left="50%"
          transform="translate(-10%, -50%)"
          textAlign="center"
        >
          <Stack spacing={2.5} justifyContent="center" alignItems="center">
            {title && (
              <Heading as="h2" size="xl">
                {title}
              </Heading>
            )}
            {content && <Text>{content}</Text>}
            {parsedLink && (
              <Button as={Link} to={parsedLink.url} variant="blue" onClick={handleTrackingClick}>
                {parsedLink.title}
              </Button>
            )}
          </Stack>
        </Box>

        <Illustration name="dandelion" pos="absolute" left="51%" bottom="10px" />
        <Illustration name="spores" w="156px" h="217px" pos="absolute" right="0" top="0" />
      </Box>
    </Container>
  )
}

export default React.memo(CallToActionDesktop)
